module.exports = __webpack_public_path__ + "_assets/img/LimitedTimeMission-Stpes-Detail-BG.6f2a608f.svg";